const login = {
  page: {
    title: 'Ihr Login',
    subtitle: 'Bitte melden Sie sich hier mit Ihren Zugangsdaten an',
  },
  errorMessage: 'Der Benutzername oder das Kennwort ist falsch.',
  newHere: 'New here?',
  join: 'Jetzt registrieren',
  forgotPassword: 'Passwort vergessen?',
  validation: {
    email: {
      format: 'Dies ist keine gültige E-Mail-Adresse. Bitte prüfen Sie Ihre Eingabe',
      empty: 'E-Mail-Adresse darf nicht leer sein.',
    },
    password: {
      length: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      empty: 'Passwort darf nicht leer sein.',
    },
    global: {
      notFound: 'Zu dieser E-Mail-Adresse konnte kein verifiziertes Kundenkonto gefunden werden.',
      invalidCredentials: 'The entered password is invalid. Please check your entry and re-enter your password.',
      notEnabled: 'Zu dieser E-Mail-Adresse konnte kein verifiziertes Kundenkonto gefunden werden.',
      ownershipError: 'Your session has expired, so your shopping cart has been deleted for security reasons. Please log in again.',
    },
  },
}

export default login
